import { network } from 'services/network';

export const getComponentLiteList = () => {
    const url = `api/bo/narratives/getComponentLiteList`;
    return network.post(url).then((response) => {
        return response.data;
    });
};
